import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { PRINT_PAGE_STYLE } from "../../../utils/printPageStyle";
import "./notification.css";

function Notification({ notification }) {
  const { date, message, target_url } = notification;
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();

  // Štampa se samo izabrano obaveštenje (ne ceo ekran aplikacije)
  const printRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: PRINT_PAGE_STYLE,
  });

  const goto = (url) => {
    setShowDropdown(false);
    navigate(url || "/admin/poslovni-procesi");
  };

  return (
    <div className="notification">
      <span>{date}</span>
      <span className="notification-message">{message}</span>
      <div className="sort-options-dropdown">
        <div
          className="sort-options-dropdown-selected"
          onClick={() => {
            setShowDropdown((state) => !state);
          }}
        >
          <span style={{ marginRight: "7px" }}>Opcije</span>

          <img
            src="/images/sidebararrow.png"
            className="sidebar-navigation-item-arrow"
          ></img>
        </div>
        {showDropdown && (
          <ul
            className="sort-options-dropdown-options"
            style={{ left: "unset", zIndex: "100", top: "calc(100% + 16px)" }}
          >
            <li
              className="sort-options-dropdown-options-item"
              onClick={() => goto(target_url)}
            >
              Pregledajte
            </li>
            <li
              className="sort-options-dropdown-options-item"
              onClick={() => goto(target_url)}
            >
              Izmenite
            </li>
            <li
              className="sort-options-dropdown-options-item"
              onClick={() => {
                setShowDropdown(false);
                handlePrint();
              }}
            >
              Odštampaj
            </li>
          </ul>
        )}
      </div>
      <div style={{ display: "none" }}>
        <div ref={printRef} style={{ padding: "20px", color: "black" }}>
          <h3 style={{ marginBottom: "10px" }}>OBAVEŠTENJE</h3>
          <p style={{ marginBottom: "10px" }}>{date}</p>
          <p style={{ whiteSpace: "pre-wrap" }}>{message}</p>
        </div>
      </div>
    </div>
  );
}

export default Notification;
